<template>
    <ToolbarDropdown :is-locked="isLocked">
        <template v-slot:toggle>
            <img
                src="/default-images/whiteboard/tool-circle-fixed.svg"
                width="20px"
            />
        </template>
        <div
            class="
                bg-white
                p-1
                flex
                gap-2
                items-center
                justify-center
                player-tool-container
            "
            v-if="props.sport == 'basketball'"
        >
            <button
                type="button"
                @click="emit('action', 'drawBasketPlayer')"
                class="flex items-center justify-center"
            >
                <img
                    src="/default-images/whiteboard/tool-basket-player.webp"
                    width="15"
                    height="15"
                />
            </button>
            <button type="button" @click="currentTool = 'circleFixed'">
                <div
                    class="
                        w-[20px]
                        h-[20px]
                        rounded-[40px]
                        !border-solid
                        border-[#000]
                        !border-[3px]
                    "
                ></div>
            </button>
            <button type="button" @click="currentTool = 'circleFilled'">
                <div class="w-[20px] h-[20px] rounded-[20px] !bg-[#000]"></div>
            </button>
            <button type="button" @click="currentTool = 'circleWithCross'">
                <img
                    src="/default-images/whiteboard/tool-circle-with-cross.svg"
                    width="40"
                    height="40"
                />
            </button>
            <button
                type="button"
                @click="currentTool = 'Cross'"
                class="flex justify-center"
            >
                <img
                    src="/default-images/whiteboard/tool-cross.svg"
                    width="30"
                    height="30"
                />
            </button>
            <button type="button" @click="currentTool = 'offense:pg'">
                <div
                    class="
                        !text-[12px]
                        font-bold
                        w-[25px]
                        h-[25px]
                        rounded-[20px]
                        !border-solid !border-[3px] !border-[#000]
                        flex
                        items-center
                        justify-center
                    "
                >
                    PG
                </div>
            </button>
            <button type="button" @click="currentTool = 'offense:1'">
                <div
                    class="
                        !text-[12px]
                        font-bold
                        w-[25px]
                        h-[25px]
                        rounded-[20px]
                        !border-solid !border-[3px] !border-[#000]
                        flex
                        items-center
                        justify-center
                    "
                >
                    1
                </div>
            </button>
            <button
                type="button"
                @click="currentTool = 'offense:basket-pg'"
                class="
                    text-[14px]
                    font-bold
                    w-[20px]
                    h-[20px]
                    rounded-[20px]
                    !border-solid !border-[3px]
                    flex
                    items-center
                    justify-center
                "
                style="
                    background: url('/default-images/whiteboard/basket.webp');
                    background-size: 25px 25px;
                    background-position: center center;
                    background-repeat: no-repeat;
                "
            >
                PG
            </button>

            <button
                type="button"
                @click="currentTool = 'offense:basket-1'"
                class="
                    text-[14px]
                    font-bold
                    w-[20px]
                    h-[20px]
                    rounded-[40px]
                    !border-solid !border-[3px]
                    flex
                    items-center
                    justify-center
                "
                style="
                    background: url('/default-images/whiteboard/basket.webp');
                    background-size: 25px 25px;
                    background-position: center center;
                    background-repeat: no-repeat;
                "
            >
                1
            </button>

            <button
                type="button"
                @click="currentTool = 'defense:x-pg'"
                class="
                    text-[16px]
                    font-bold
                    w-[20px]
                    h-[20px]
                    flex
                    items-center
                    justify-center
                    relative
                "
            >
                <img
                    src="/default-images/whiteboard/cross.svg"
                    style="
                        position: absolute;
                        width: 25px;
                        height: 25px;
                        transform: translate(0%, 0%);
                        z-index: 0;
                        opacity: 0.5;
                    "
                    width="20"
                />
                PG
            </button>
            <button
                type="button"
                @click="currentTool = 'defense:x-1'"
                class="
                    text-[16px]
                    font-bold
                    w-[20px]
                    h-[20px]
                    flex
                    items-center
                    justify-center
                    relative
                "
            >
                <img
                    src="/default-images/whiteboard/cross.svg"
                    style="
                        position: absolute;
                        width: 25px;
                        height: 25px;
                        transform: translate(0%, 0%);
                        z-index: 0;
                        opacity: 0.5;
                    "
                    width="20"
                />
                1
            </button>

            <button type="button" @click="currentTool = 'icon:trophy-outline'">
                <div
                    class="
                        !text-[14px]
                        font-bold
                        w-[25px]
                        h-[25px]
                        rounded-[20px]
                        !border-solid !border-[3px] !border-[#000]
                        flex
                        items-center
                        justify-center
                    "
                >
                    <ion-icon
                        name="trophy-outline"
                        role="img"
                        class="md hydrated"
                        aria-label="trophy outline"
                    ></ion-icon>
                </div>
            </button>
        </div>
        <div
            class="
                bg-white
                p-1
                flex
                gap-2
                items-center
                justify-center
                player-tool-container
            "
            v-else
        >
            <button
                type="button"
                @click="currentTool = 'ShadedCross'"
                class="flex items-center justify-center"
            >
                <img
                    src="/default-images/whiteboard/tool-shaded-cross.svg"
                    width="20"
                    height="20"
                />
            </button>

            <button type="button" @click="currentTool = 'circleFixed'">
                <div
                    class="
                        w-[20px]
                        h-[20px]
                        rounded-[40px]
                        !border-solid
                        border-[#000]
                        !border-[3px]
                    "
                ></div>
            </button>
            <button type="button" @click="currentTool = 'circleFilled'">
                <div class="w-[20px] h-[20px] rounded-[20px] !bg-[#000]"></div>
            </button>
            <button type="button" @click="currentTool = 'circleWithCross'">
                <img
                    src="/default-images/whiteboard/tool-circle-with-cross.svg"
                    width="40"
                    height="40"
                />
            </button>
            <button
                type="button"
                v-for="letter in [
                    'F',
                    'X',
                    'Y',
                    'Z',
                    'H',
                    'Q',
                    'TE',
                    'TE2',
                    'R',
                    'WR1',
                    'WR2',
                    'WR3',
                    'WR4',
                ]"
                @click="currentTool = `offense:${letter}`"
                :key="letter"
            >
                <div
                    class="
                        !text-[10px]
                        font-bold
                        w-[25px]
                        h-[25px]
                        rounded-[20px]
                        !border-solid !border-[3px] !border-[#000]
                        flex
                        items-center
                        justify-center
                    "
                >
                    {{ letter }}
                </div>
            </button>

            <button type="button" @click="currentTool = `offense:A`">
                <div
                    class="
                        !text-[12px]
                        font-bold
                        w-[25px]
                        h-[25px]
                        rounded-[20px]
                        !border-solid !border-[3px] !border-[#000]
                        flex
                        items-center
                        justify-center
                    "
                >
                    {{ letter }}
                    A+
                </div>
            </button>

            <button type="button" @click="currentTool = 'icon:flame-outline'">
                <div
                    class="
                        !text-[14px]
                        font-bold
                        w-[25px]
                        h-[25px]
                        rounded-[40px]
                        !border-solid !border-[3px]
                        border-[#000]
                        flex
                        items-center
                        justify-center
                    "
                >
                    <ion-icon
                        name="flame-outline"
                        role="img"
                        class="md hydrated"
                        aria-label="flame outline"
                    ></ion-icon>
                </div>
            </button>
        </div>
    </ToolbarDropdown>

    <ToolbarDropdown v-if="props.sport != 'basketball'">
        <template v-slot:toggle>
            <div class="text-[16px]">M</div>
        </template>

        <div
            class="
                bg-white
                p-1
                flex
                gap-2
                items-center
                justify-center
                player-tool-container
            "
        >
            <button
                type="button"
                @click="currentTool = 'Cross'"
                class="flex items-center justify-center"
            >
                <img
                    src="/default-images/whiteboard/tool-cross.svg"
                    width="15"
                />
            </button>

            <button
                type="button"
                v-for="letter in [
                    'M',
                    'W',
                    'S',
                    'DB',
                    'LB',
                    'FS',
                    'SS',
                    'CB',
                    'DE',
                    'NT',
                    'DT',
                    'T',
                    'U',
                    '$',
                    'D',
                    'L',
                    'B',
                    'WS',
                ]"
                @click="currentTool = `defense:${letter}`"
                :key="letter"
                class="
                    text-[16px]
                    font-bold
                    w-[20px]
                    h-[20px]
                    rounded-[40px]
                    flex
                    items-center
                    justify-center
                "
            >
                {{ letter }}
            </button>

            <button
                type="button"
                @click="currentTool = `defense:A`"
                class="
                    text-[16px]
                    font-bold
                    w-[20px]
                    h-[20px]
                    rounded-[40px]
                    flex
                    items-center
                    justify-center
                "
            >
                A+
            </button>

            <button
                type="button"
                @click="currentTool = 'icon:anchor-outline:no-border'"
                class="
                    text-[14px]
                    font-bold
                    w-[20px]
                    h-[20px]
                    rounded-[40px]
                    flex
                    items-center
                    justify-center
                "
            >
                <img
                    src="/default-images/whiteboard/icons/anchor-outline.svg"
                    width="15"
                />
            </button>
        </div>
    </ToolbarDropdown>
</template>
<script setup>
import useWhiteboard from "../useWhiteboard";
import { defineProps, defineEmits } from "vue";
const { currentTool, isLocked } = useWhiteboard();
const props = defineProps(["sport"]);
const emit = defineEmits(["action"]);
</script>

<style scoped>
.player-tool-container {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
}

.player-tool-container button {
    border: 1px solid #f6f6f6 !important;
    padding: 6px;
    border-radius: 8px;
    height: 35px;
    font-size: 12px;
    font-weight: 600 !important;
}
</style>
